!(function () {
  "use strict";
  const t = "cart-drawer-complementary-products",
    e = "data-url";
  class s extends HTMLElement {
    constructor() {
      super();
      this._observer = null;
      this._onCartUpdated = this._onCartUpdated.bind(this);
    }
    connectedCallback() {
      this._initObserver();
      window.addEventListener("theme:cart:change", this._onCartUpdated);
      window.addEventListener("theme:product:added", this._onCartUpdated);
    }
    disconnectedCallback() {
      this._observer && this._observer.disconnect();
      window.removeEventListener("theme:cart:change", this._onCartUpdated);
      window.removeEventListener("theme:product:added", this._onCartUpdated);
    }
    _initObserver() {
      (this._observer = new IntersectionObserver(
        ((s, r) => {
          s[0].isIntersecting &&
            (r.unobserve(this),
            this.hasAttribute(e) &&
              "" !== this.getAttribute(e) &&
              this._fetchAndRender());
        }).bind(this),
        { rootMargin: "0px 0px 400px 0px" }
      )).observe(this);
    }
    _fetchAndRender() {
      fetch(this.getAttribute(e))
        .then((t) => t.text())
        .then((e) => {
          const s = document.createElement("div");
          (s.innerHTML = e), this._renderContent(s);
        })
        .catch((t) => {
          console.error(t);
        });
    }
    _renderContent(s) {
      const upsellWidget = document.querySelector('[data-upsell-widget]');
      if (upsellWidget) {
        upsellWidget.style.visibility = 'visible';
          upsellWidget.style.height = '100%';
          upsellWidget.querySelector('.cart__widget__title').style.cssText = '';
      }
      const r = s.querySelector(t);
      if (r && r.innerHTML.trim().length) {
        this.innerHTML = r.innerHTML;
        this.dispatchEvent(
          new CustomEvent("theme:complementary:loaded", {
            bubbles: !0,
            detail: { container: this },
          })
        );
        
      } else {
        // Render blank and hide upsell widget if no recommendations
        this.innerHTML = '';
        if (upsellWidget) {
          upsellWidget.style.visibility = 'hidden';
          upsellWidget.style.height = '0%';
          upsellWidget.querySelector('.cart__widget__title').style.cssText = 'display:none;';
        }
      }
    }
    _onCartUpdated() {
      // On cart change, update data-url with last cart item's product_id, then re-fetch
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          if (cart.items && cart.items.length > 0) {
            const lastItem = cart.items[0];
            const url = new URL(this.getAttribute(e), window.location.origin);
            url.searchParams.set('product_id', lastItem.product_id);
            this.setAttribute(e, url.pathname + url.search);
            console.log(`Updated data-url to: ${this.getAttribute(e)}`);
          }
          this.hasAttribute(e) && null !== this.offsetParent && this._fetchAndRender();
        })
        .catch(() => {
          // fallback: just reload
          this.hasAttribute(e) && null !== this.offsetParent && this._fetchAndRender();
        });
    }
  }
  customElements.get("cart-drawer-complementary-products") ||
    customElements.define("cart-drawer-complementary-products", s);
})();
